import { useSelector } from 'react-redux';
import { selectRequestedQuery } from '@client/catalog/redux/search/redux';

export function useSearchRequestedQuery(): string {
  return useSelector(selectRequestedQuery);
}
